import React from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from "../variants";
import { Link } from 'react-scroll';
import Img1 from '../assets/portfolio-img1.png';
import Img2 from '../assets/portfolio-img2.png';
import Img3 from '../assets/portfolio-img3.png';
import Img4 from '../assets/portfolio-img4.png';

const Work = () => {
  
  return (
    <section className='section h-auto' id='work'>
    <div className="container mx-auto">
      <div className='flex flex-col lg:flex-row justify-between ml:h-[900px] mi:h-[1200px] lg:h-[1200px] flex-wrap'>
        <motion.div 
        variants={fadeIn('right', 0.3)}
        initial="hidden"
        whileInView={'show'}
        viewport={{ once: false, amount: 0.3}}
        className='flex flex-col h-[38.5%] w-[100%] lg:h-[65%] lg:w-[48%] justify-between'>

          <div className='h-[47%] w-full flex flex-col justify-between'>
            <h2 className='h3 text-[18px] mi:text-[21px] mo:text-[26px] lg:text-[32px] lg:h2 leading-tight text-accent ml:mb-0 lg:mb-[1.5rem]'>
              My Latest <br/>
              Work.
            </h2>
            <p className='max-w-sm lg:mb-16 ml:leading-[1rem] ml:text-[0.8rem] lg:leading-[2rem] mi:text-[1rem] lg:text-[1.35rem]'>Here are presented projects made by me or for the creation of which my talents were also invested. I did these projects while working in the best institutions of Armenia.</p>
            <a href="https://freelance.habr.com/freelancers/SinCode/projects?category=development_frontend" className='btn flex justify-center items-center cursor-pointer btn-sm w-[max-content] text-[0.65rem] h-[34px] mi:h-[48px] mi:text-[0.875rem]'>View all projects</a>
          </div>

          {/* Images */}
          <a href='https://lachain.io/' className='group relative overflow-hidden border-2 border-white/50 rounded-xl h-[47%] w-full'>
            <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>

            <img src={Img1} alt="#" className='group-hover:scale-125 transition-all duration-500 w-full h-full object-cover'/>

            <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
              <span className='text-gradient'>FrontEnd</span>
            </div>

            <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
              <span className='text-3xl text-white'>Asset Launch</span>
            </div>
          </a>
        </motion.div>
        <motion.div 
        variants={fadeIn('left', 0.3)}
        initial="hidden"
        whileInView={'show'}
        viewport={{ once: false, amount: 0.3}}
        className='flex flex-col h-[38.5%] w-[100%] lg:h-[65%] lg:w-[48%] justify-between'>
          <a href="https://sustaindao.xyz/" className='group relative overflow-hidden border-2 border-white/50 rounded-xl h-[47%] w-full'>
            <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>

            <img src={Img2} alt="#" className='group-hover:scale-125 transition-all duration-500 w-full h-full object-cover'/>

            <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
              <span className='text-gradient'>FrontEnd</span>
            </div>

            <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
              <span className='text-3xl text-white'>Сryptocurrencies</span>
            </div>
          </a>
          <a href="https://adultmembersites.com/" className='group relative overflow-hidden border-2 border-white/50 rounded-xl h-[47%] w-full'>
            <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>

            <img src={Img3} alt="#" className='group-hover:scale-125 transition-all duration-500 w-full h-full object-cover'/>

            <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
              <span className='text-gradient'>FrontEnd</span>
            </div>

            <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
              <span className='text-3xl text-white'>18+</span>
            </div>
          </a>
        </motion.div>
        <motion.div 
        variants={fadeIn('right', 0.3)}
        initial="hidden"
        whileInView={'show'}
        viewport={{ once: false, amount: 0.3}}
        className='flex flex-col h-[18.5%] w-[100%] lg:h-[30%] lg:w-[48%] justify-between'>
          <a href="https://trinity-eta.vercel.app/" className='group relative overflow-hidden border-2 border-white/50 rounded-xl h-full w-full'>
            <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>

            <img src={Img4} alt="#" className='group-hover:scale-125 transition-all duration-500 w-full h-full object-cover'/>

            <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
              <span className='text-gradient'>FrontEnd</span>
            </div>

            <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
              <span className='text-3xl text-white'>Car Rental</span>
            </div>
          </a>
        </motion.div>
      </div>
    </div>
  </section>
)
};

export default Work;